import { SectionGroup, SVG } from '@sleepstation/components'
import { BreakingLayout, VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { DIRECTION, LAYOUT_SPACING } from '@sleepstation/const'
import { parseToAst } from '@sleepstation/markdown'
import { mq, top } from '@sleepstation/style-api-helpers'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import BreakoutModuleWide from '../../../../shared/breakoutModules/BreakoutModuleWide'
import Charts from './Charts'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const MAX_IMAGE_WIDTH_PX = 411
const MIN_IMAGE_WIDTH_PX_LARGE = MAX_IMAGE_WIDTH_PX
const MIN_IMAGE_WIDTH_PX_MEDIUM = 288

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.X_LARGE,
  'data-cy': `sleep-and-emotions-section`,
})``

const Primary = styled(BreakingLayout).attrs({
  spacing: LAYOUT_SPACING.X_LARGE,
  direction: [
    DIRECTION.VERTICAL_REVERSED,
    DIRECTION.VERTICAL_REVERSED,
    DIRECTION.HORIZONTAL,
  ],
})`
  width: 100%;
`

const ImageWrapper = styled.div`
  flex-grow: 2;
  width: 100%;

  ${mq(`mediumOnly`)} {
    ${top(3)}
    min-width: ${rem(MIN_IMAGE_WIDTH_PX_MEDIUM)};
  }

  ${mq(`largeUp`)} {
    ${top(3)}
    min-width: ${rem(MIN_IMAGE_WIDTH_PX_LARGE)};
  }

  ${mq(`mediumUp`)} {
    position: relative;
  }

  ${mq(`mediumDown`)} {
    align-self: center;
    max-width: ${rem(MAX_IMAGE_WIDTH_PX)};
  }

  > svg {
    width: 100%;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SleepAndEmotionsSection = ({ data }) => {
  const { title, subtitle, description, illustrationSvg, ...rest } = data

  return (
    <BreakoutModuleWide
      hasBottomBorder
      hasGradient
      paddingV={[
        [2, 0],
        [3, 0],
        [3, 1],
        [3, 2],
      ]}
    >
      <Layout>
        <Primary>
          <SectionGroup title={title} spacing={[0.5, 1]} bodySpacing={[0.5, 1]}>
            <CopyRenderer htmlAst={parseToAst(`**${subtitle}**`)} />
            <CopyRenderer htmlAst={parseToAst(description)} />
          </SectionGroup>
          <ImageWrapper>
            <SVG svg={illustrationSvg} />
          </ImageWrapper>
        </Primary>
        <Charts {...rest} />
      </Layout>
    </BreakoutModuleWide>
  )
}

SleepAndEmotionsSection.propTypes = {
  data: PropTypes.object.isRequired,
}

SleepAndEmotionsSection.defaultProps = {}

export default SleepAndEmotionsSection
